import { supabase } from '../../utils/supabase_config';

export class QuickBooksService {
  static async getStatus() {
    const { data, error } = await supabase.functions.invoke('quickbooks-status');
    if (error) throw error;
    return data; // { connected, realmId, expiresAt }
  }

  static async authorize() {
    const { data, error } = await supabase.functions.invoke('quickbooks-auth');
    if (error) throw error;
    window.location.href = data.url;
  }

  static async createInvoice(payload) {
    const { data, error } = await supabase.functions.invoke('quickbooks-invoice', { body: payload });
    if (error) throw error;
    if (data?.error) throw new Error(data.error);
    return data; // { invoiceId, invoiceNumber, totalAmt }
  }

  static async createVendorBill(payload) {
    const { data, error } = await supabase.functions.invoke('quickbooks-vendor-bill', { body: payload });
    if (error) throw error;
    if (data?.error) throw new Error(data.error);
    return data; // { billId, totalAmt }
  }
}
